import { Page404, PageLoading, ResetPassword } from '@you-go-vn/components';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { authService } from '../auth/services';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!!email && !!token) {
      setLoading(false);
      return;
    }
  }, [token, email]);
  if (loading) return <PageLoading />;
  if (!email || !token) return <Page404 />;
  return (
    <ResetPassword
      token={token}
      onFinish={async (values) => {
        const hideMessage = message.loading('Đang đặt lại mật khẩu', 0);
        try {
          const res = await authService.updatePassword(
            {
              newPassword: values.password,
              passwordConfirmation: values.passwordConfirmation,
            },
            token,
          );
          if (res.data.message === 'success') {
            message.success('Thành công');
            return { success: true };
          }
          if (res.data.errors) {
            message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');
            return { errors: res.data.errors };
          }
          throw new Error();
        } catch (error: any) {
          message.error('Đã xảy ra lỗi, vui lòng kiểm tra lại!');
          // if has field error

          if (error.response) {
            return { errors: error.response.data.errors };
          }
          return {};
        } finally {
          hideMessage();
        }
      }}
    />
  );
};

export default ResetPasswordPage;
